/** @jsxImportSource @emotion/react */
import { Icon } from '@ssmm/ui';
import faq from 'components/landing/settings/faq';
import {
  BlueLine,
  colors,
  Container,
  HeadingH2,
  HeadingH3,
  Section,
  Text,
} from 'components/landing/ui';
import { useState } from 'react';

import FAQButton from './button';

const S9 = () => {
  const [activeSection, setActiveSection] = useState('safety');
  const [activeIssueIndex, setActiveIssueIndex] = useState(0);

  const handleSectionClick = s => {
    setActiveIssueIndex(0);
    setActiveSection(s);
  };

  const handleIssueClick = i => {
    setActiveIssueIndex(i === activeIssueIndex ? 999 : i);
  };

  return (
    <Container css={{ overflow: 'hidden' }}>
      <Section
        css={{
          paddingTop: 50,
          paddingBottom: 80,
          '@media (min-width:992px)': { paddingTop: 100, paddingBottom: 120 },
          '@media (min-width:1366px)': { paddingTop: 120, paddingBottom: 150 },
        }}
      >
        <div
          css={{
            flexDirection: 'column',
            alignItems: 'flex-start',
            width: '100%',
          }}
        >
          <div
            css={{
              flexDirection: 'column',
              alignItems: 'center',
              width: '100%',
              marginBottom: 30,
              '@media (min-width:992px)': { alignItems: 'flex-start', marginBottom: 50 },
            }}
          >
            <HeadingH2 css={{ marginBottom: 20 }}>чАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ</HeadingH2>
            <BlueLine height={5} width={125} />
          </div>

          <div
            css={{
              flexDirection: 'column',
              width: '100%',
              '@media (min-width:992px)': { flexDirection: 'row' },
            }}
          >
            <div
              css={{
                marginBottom: 30,
                flexDirection: 'row',
                '>div': { flexBasis: '30%', flexGrow: 1 },
                '>div:not(:last-of-type)': { marginRight: 15 },
                '@media (min-width:992px)': {
                  flexDirection: 'column',
                  flex: `0 0 350px`,
                  marginRight: 30,
                  marginBottom: 0,
                  '>div': { width: '100%', flexBasis: 'unset', flexShrink: 0, flexGrow: 0 },
                  '>div:not(:last-of-type)': { marginRight: 0, marginBottom: 25 },
                },
                '@media (min-width:1363px)': {
                  flex: `0 0 278px`,
                  marginRight: 50,
                },
              }}
            >
              {Object.keys(faq).map(k => (
                <FAQButton
                  key={k}
                  active={k === activeSection}
                  onClick={() => handleSectionClick(k)}
                >
                  {faq[k].title}
                </FAQButton>
              ))}
            </div>

            <div
              css={{
                width: '100%',
                flexDirection: 'column',
                '>div': {
                  background: '#fff',
                  padding: 25,
                  width: '100%',
                  flexDirection: 'column',
                  borderRadius: 4,
                  border: `1px solid ${colors.grayDark}`,
                },
                '>div:not(:last-of-type)': { marginBottom: 15 },
                '@media (min-width:992px)': {
                  width: 'unset',
                  flexGrow: 1,
                },
              }}
            >
              {faq[activeSection].issues.map((i, idx) => {
                const active = idx === activeIssueIndex;

                return (
                  <div
                    key={idx}
                    css={{
                      overflow: 'hidden',
                      maxHeight: active ? 'unset' : 78,
                    }}
                  >
                    <div
                      css={{
                        justifyContent: 'space-between',
                        cursor: 'pointer',
                        ':hover': { h3: { color: colors.blue } },
                      }}
                      onClick={() => handleIssueClick(idx)}
                    >
                      <HeadingH3 css={{ color: active ? colors.blue : colors.black }}>
                        {i.title}
                      </HeadingH3>
                      <Icon
                        color={active ? colors.blue : colors.black}
                        css={{ transform: active ? 'rotate(-90deg)' : 'none' }}
                        svg={`<svg width="25" height="26" viewBox="0 0 25 26" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.71823 5.40768C10.1759 4.95004 10.9179 4.95004 11.3755 5.40768L18.0161 12.0483C18.4737 12.5059 18.4737 13.2479 18.0161 13.7056L11.3755 20.3462C10.9179 20.8038 10.1759 20.8038 9.71823 20.3462C9.26059 19.8885 9.26059 19.1466 9.71823 18.689L15.5302 12.8769L9.71823 7.06497C9.26059 6.60732 9.26059 5.86532 9.71823 5.40768Z" />
</svg>`}
                      />
                    </div>
                    <div
                      css={{
                        marginTop: 25,
                        paddingTop: 20,
                        borderTop: `1px solid ${colors.grayLight}`,
                      }}
                    >
                      <Text>{i.description}</Text>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </Section>
    </Container>
  );
};

export default S9;
